import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';

import { useAuth } from '../Session';
import SignOutButton from '../SignOutButton';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';
import { FaBars } from 'react-icons/fa';

const navLinkClass = ({ isActive }) => `nav-link js-scroll-trigger${isActive ? ' active-nav' : ''}`;

const Navigation = () => {
  const { authUser, loading } = useAuth();

  if (loading) {
    return (
      <Navbar expand="lg" variant="dark" fixed="top" id="navbar-main" className="navbar-dark">
        <Container>
          <HomeLogo />
        </Container>
      </Navbar>
    );
  }

  return authUser ? <NavigationAuth authUser={authUser} /> : <NavigationNonAuth />;
};

const HomeLogo = ({ onNavigate }) => (
  <Navbar.Brand href="/" className="js-scroll-trigger p-0 navbar-brand-lockup" onClick={onNavigate}>
    <img className="navbar-brand-logo" src="/img/logo-cash.png" alt="Zenreki.Cash" />
    <span className="navbar-brand-text">ZENREKI.CASH</span>
  </Navbar.Brand>
);

const NavMenuLink = ({ to, end, children, onNavigate }) => (
  <Nav.Link as={NavLink} end={end} className={navLinkClass} to={to} onClick={onNavigate}>
    {children}
  </Nav.Link>
);

const NavigationShell = ({ children }) => {
  const [expanded, setExpanded] = useState(false);
  const closeMenu = () => setExpanded(false);

  return (
    <Navbar
      expand="lg"
      variant="dark"
      fixed="top"
      id="navbar-main"
      className="navbar-dark"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container>
        <HomeLogo onNavigate={closeMenu} />
        <Navbar.Toggle aria-controls="navbarSupportedContent">
          <FaBars style={{ color: '#ffbf00' }} />
        </Navbar.Toggle>
        <Navbar.Collapse id="navbarSupportedContent">
          <Nav className="ml-auto">
            {typeof children === 'function' ? children(closeMenu) : children}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

const NavigationNonAuth = () => (
  <NavigationShell>
    {(closeMenu) => (
      <>
        <NavMenuLink to={ROUTES.HOME} end onNavigate={closeMenu}>
          Home
        </NavMenuLink>
        <NavMenuLink to={ROUTES.COINS_CASE} end onNavigate={closeMenu}>
          Coins
        </NavMenuLink>
        <NavMenuLink to={ROUTES.SIGN_UP} end onNavigate={closeMenu}>
          Sign Up
        </NavMenuLink>
        <NavMenuLink to={ROUTES.SIGN_IN} end onNavigate={closeMenu}>
          Sign In
        </NavMenuLink>
      </>
    )}
  </NavigationShell>
);

const NavigationAuth = ({ authUser }) => (
  <NavigationShell>
    {(closeMenu) => (
      <>
        {!!authUser.roles?.[ROLES.ADMIN] && (
          <NavMenuLink to={ROUTES.ADMIN} onNavigate={closeMenu}>
            Admin
          </NavMenuLink>
        )}
        <NavMenuLink to={ROUTES.DASHBOARD} end onNavigate={closeMenu}>
          Dashboard
        </NavMenuLink>
        <NavMenuLink to={ROUTES.COINS_CASE} end onNavigate={closeMenu}>
          Coins
        </NavMenuLink>
        <NavMenuLink to={ROUTES.ACCOUNT} end onNavigate={closeMenu}>
          Account
        </NavMenuLink>
        <SignOutButton onNavigate={closeMenu} />
      </>
    )}
  </NavigationShell>
);

export default Navigation;
